<template>
  <div class="heading">
    <div class="headerCopy">
      <h1>
        Askaway. An open-source tool for facilitating
        <span class="highlight"> Q&A sessions remotely.</span>
      </h1>
      <span class="subTitleWrapper">
        <hr class="line">
        <span class="lineCopy" v-on:click="openGitHub()">Get Askaway</span>
      </span>
      <Created />
    </div>
  </div>
</template>

<script>
import Created from "../components/Created.vue";

export default {
  name: "Hero",
  components: {
    Created,
  },
  props: {
    msg: String
  },
  methods: {
    openGitHub() {
      window.open('https://github.com/myplanet/askaway', '_blank')
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.heading {
  width: 100%;
  height: 40vh;
  min-height: 400px;
  align-items: center;
}
h1 {
  font-size: 60px;
  font-family: "SofiaProBold";
  color: black;
  line-height: 80px;
}

.heading .littletitle {
  font-size: 15px;
  text-align: left;
  margin-bottom: 20px;
  color: #e1e0e6;
}

.highlight {
  color: #f25930;
}
.subTitleWrapper {
  align-items: center;
}
.lineCopy {
  cursor: pointer;
  width: 145px;
  color: #9292a8;
  font-size: 24px;
  line-height: 23px;
  margin-left: 20px;
  font-family: "SofiaProRegular";
}

.subTitleWrapper .line {
  display: inline-block;
  width: 75px;
}

.headerCopy {
  width: 60%;
  margin: 0 auto;
  text-align: left;
  margin-top: 30vh;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-width: 824px) and (max-width: 1028px) {
  .headerCopy {
    width: 80%;
  }

  h1 {
  }

  .heading {
    margin-bottom: 150px;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .headerCopy {
    width: 80%;
  }

  h1 {
  }

  .heading {
    margin-bottom: 150px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .headerCopy {
    width: 80%;
  }

  h1 {
    font-size: 40px;
    line-height: 53.3px;
  }

  .heading {
    height: 30vh;
    min-height: 0px;
    margin-bottom: 150px;
  }

  .subTitleWrapper .line {
    display: none;
  }

  .lineCopy {
    margin-left: 5px;
    font-size: 20px;
    line-height: 26.6px;
  }
}
</style>
